import React from 'react';
import { useNotifications } from 'contexts/notifications';
import { NotificationBadge } from './styles';

export const RenderNotificationTagNumber = ({ name }: { name: string }) => {
  const { notifications } = useNotifications();
  const lengthUnread = notifications?.filter((notification) => !notification.read)?.length;
  if (name === 'notifications' && lengthUnread > 0)
    return <NotificationBadge>{lengthUnread > 99 ? '99+' : lengthUnread}</NotificationBadge>;

  return null;
};
